module.exports = __webpack_public_path__ + "static/media/PDF13.fb015699.pdf";